import { useFilters } from 'Admin/Partners/hooks/useFilters';
import { Formik } from 'formik';
import React from 'react';
import { ClearFilterButton } from 'Shared/components/ClearFilterButtons';
import { FormInput } from 'Shared/components/FormInput';

import styles from '../../Admin/Partners/components/PartnerFilters/styles.module.css';

export type MoratoriumsFilterType = {
  name?: string;
};

const ALLOWED_FILTERS: Array<keyof MoratoriumsFilterType> = ['name'];

export const MoratoriumsFilters: React.FC<{
  filters: MoratoriumsFilterType;
  onChangeFilters(filters: MoratoriumsFilterType): void;
}> = ({ filters, onChangeFilters }) => {
  const { updateFilters, clearAllFilters } = useFilters<MoratoriumsFilterType>({
    allowedFilters: ALLOWED_FILTERS,
    onChangeFilters,
  });

  return (
    <Formik enableReinitialize initialValues={filters} onSubmit={updateFilters}>
      {({ handleSubmit, values, handleChange }) => (
        <form
          onSubmit={handleSubmit}
          className={styles.search}
          data-testid="form"
        >
          <FormInput
            name="name"
            className={styles.searchInput}
            value={values.name || ''}
            label="Search name"
            variant="search"
            onChange={handleChange}
            onIconClick={() => {
              handleSubmit();
            }}
          />
          <button
            data-testid="filter-submit"
            type="submit"
            className={styles.submit}
          />
          <div className={styles.clearContainer}>
            <ClearFilterButton
              onClick={clearAllFilters}
              disabled={!Object.keys(filters).length}
              data-testid="clear-filters"
            >
              Clear Search
            </ClearFilterButton>
          </div>
        </form>
      )}
    </Formik>
  );
};
